import { ButtonUploadComponent } from './button-upload.component';

export default angular
  .module('sfMobile.components.button-upload', [
    'sfMobile.components.loader',
    'sfMobile.components.spinner',
  ])
  .component('sfButtonUpload', ButtonUploadComponent).name;
